<template>
  <admin title="Transações" menu="Transações">
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <div class="block_info_white bg_black p-2">
          <div class="row">
            <div class="col-lg-4 col-xs-12">
              <Datepicker
                input-class="form-control"
                class="p-0"
                placeholder="Data inicial"
                v-model="initial_date"
                :format="customFormatter"
                :language="ptBR"
              ></Datepicker>
            </div>
            <div class="col-lg-4 col-xs-12">
              <Datepicker
                input-class="form-control"
                class="p-0"
                :format="customFormatter"
                placeholder="Data final"
                v-model="end_date"
                :language="ptBR"
              ></Datepicker>
            </div>
            <div class="col-lg-2 col-xs-12">
              <button type="button" @click="loadTransacations" class="btn btn-primary">
                <font-awesome-icon icon="search"></font-awesome-icon>
              </button>
            </div>
            <div class="col-lg-2 col-xs-12">
              <div class="pt-2">
                <span class="mr-2 color-light-grey">
                  <b>Total</b>
                </span>
                <span class="block_info">
                  <b>{{ transactions.length }}</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-xs-12">
        <div class="row">
          <div class="col-lg-12">
            <table class="table_jovool table_jovool_dark mt-3">
              <thead class="headerTable">
                <tr class="text-center">
                  <td class="center">Nome</td>
                  <td class="center">Valor</td>
                  <td class="center">Data Criaçao</td>
                  <td class="center">Data Atualização</td>
                  <td class="center">Status</td>
                  <td class="center">metodo de pagamento</td>
                  <td class="center">Boleto url</td>
                  <td></td>
                </tr>
              </thead>
              <tbody class="position-relative">
                <tr
                  v-for="(transaction, index) in transactions"
                  :key="transaction.id"
                  :class="{'content-loading': loading}"
                >
                  <td class="pt-4 center">
                    <div>{{transaction.recruiter.name}}</div>
                  </td>

                  <td class="pt-4 center">
                    <span>
                      R$
                      {{ transaction.amount ? parseFloat(transaction.amount/100 ).toFixed(2).replace('.', ',') : "0,00" }}
                    </span>
                  </td>

                  <td class="pt-4 center">
                    {{
                    transaction.created_at | moment("DD/MM/YYYY h:m")
                    }}
                  </td>
                  <td class="pt-4 center">
                    {{
                    transaction.updated_at | moment("DD/MM/YYYY h:m")
                    }}
                  </td>
                  <td class="pt-4 center">{{status[transaction.status]}}</td>
                  <td
                    class="pt-4 center"
                  >{{transaction.payment_method == 'credit_card' ? 'Cartão de crédito' : 'Boleto'}}</td>
                  <td>
                    <span
                      v-if="transaction.boleto_url"
                      class="pointer color-grey"
                      v-clipboard:copy="transaction.boleto_url"
                      v-clipboard:success="onCopy"
                    >
                      <font-awesome-icon icon="link" />
                    </span>
                  </td>
                  <td></td>
                </tr>
                <div class="center position-absolute loading-gif" :class="{'d-none': !loading }">
                  <img src="/images/loading.gif" alt="loading-gif" />
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </admin>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
export default {
  components: { Datepicker },
  mounted() {
    this.initial_date = this.$moment().subtract(30, "days").format();
    this.end_date = this.$moment().format();
    this.loadTransacations();
  },
  data: () => ({
    loading: false,
    ptBR: ptBR,
    transactions: [],
    initial_date: "",
    end_date: "",
    status: {
      processing: "Processo de autorização.",
      authorized: "Autorizada.",
      paid: "Paga.",
      refunded: "Estornada",
      waiting_payment: " Aguardando pagamento ",
      pending_refund: "Estorno solicitado.",
      refused: "Não autorizada.",
      chargedback: "Transação sofreu chargeback.",
      analyzing: " Análise ",
      pending_review: "Pendente",
    },
  }),
  methods: {
    searchPlans() {},
    customFormatter(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    onCopy: function (e) {
      this.$toast.success("Link Copiado com sucesso");
    },
    loadTransacations() {
      this.loading = true;
      axios
        .get("/admins/transactions/search", {
          params: {
            initial_date:
              this.$moment(this.initial_date).format("YYYY-MM-DD") + " 00:00",
            end_date:
              this.$moment(this.end_date).format("YYYY-MM-DD") + " 23:59",
          },
        })
        .then((response) => {
          this.loading = false;
          this.transactions = response.data.transactions;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>